import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'cherryTrunk',
      d: 'M0.5,-2.5h1v0.5h-1zM0,-2h1v3.5h-1zM0.5,1.5h0.5v0.5h-0.5zM0,2h1.5v0.5h-1.5z',
    },
    { paint: 'cherryBranch', d: 'M-0.5,-2h0.5v3.5h-0.5zM-1,1.5h1.5v0.5h-1.5zM-1,2h1v0.5h-1z' },
    {
      paint: [
        ['blossomPink', 0.77],
        ['cherryTrunk', 0.23],
      ],
      d: 'M-1,-8.5h1v0.5h-1zM-1.5,-8h0.5v0.5h-0.5zM0,-8h2v0.5h-2zM-3,-7.5h1.5v0.5h-1.5zM2,-7.5h0.5v0.5h-0.5zM-3.5,-7h0.5v1h-0.5zM2,-7h1v0.5h-1zM2.5,-6.5h1.5v0.5h-1.5zM-4,-6h1v0.5h-1zM3.5,-6h1v0.5h-1zM-4.5,-5.5h0.5v2h-0.5zM3,-5.5h1.5v0.5h-1.5zM2.5,-5h2v0.5h-2zM0,-4.5h2.5v0.5h-2.5zM3,-4.5h1.5v0.5h-1.5zM-2,-4h6.5v0.5h-6.5zM-4,-3.5h8.5v0.5h-8.5zM-3.5,-3h7.5v0.5h-7.5zM-2.5,-2.5h3v0.5h-3zM1.5,-2.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'blossomPink',
      d: 'M-1,-8h1v0.5h-1zM-1.5,-7.5h0.5v0.5h-0.5zM0.5,-7.5h1.5v1h-1.5zM-3,-7h0.5v0.5h-0.5zM-0.5,-6.5h3v0.5h-3zM-3,-6h0.5v0.5h-0.5zM-1.5,-6h5v0.5h-5zM-4,-5.5h7v0.5h-7zM-4,-5h4.5v0.5h-4.5zM1,-5h1.5v0.5h-1.5zM-4,-4.5h4v0.5h-4zM-4,-4h2v0.5h-2z',
    },
    {
      paint: [
        ['blossomPink', 0.3],
        ['blossomWhite', 0.7],
      ],
      d: 'M-1,-7.5h1.5v0.5h-1.5zM-2.5,-7h3v0.5h-3zM-3,-6.5h2.5v0.5h-2.5zM-2.5,-6h1v0.5h-1zM0.5,-5h0.5v0.5h-0.5zM2.5,-4.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 210,
};
const variant1: PixelSprite = {
  layers: [
    { paint: 'cherryTrunk', d: 'M0,-2.5h1v4h-1zM0.5,1.5h0.5v0.5h-0.5zM0,2h1.5v0.5h-1.5z' },
    { paint: 'cherryBranch', d: 'M-0.5,-2h0.5v3.5h-0.5zM-1,1.5h1.5v0.5h-1.5zM-1,2h1v0.5h-1z' },
    {
      paint: [
        ['blossomWhite', 0.77],
        ['cherryTrunk', 0.23],
      ],
      d: 'M0,-8h1v0.5h-1zM-2.5,-7.5h1v0.5h-1zM2,-7.5h0.5v0.5h-0.5zM2,-7h1v0.5h-1zM2.5,-6.5h0.5v0.5h-0.5zM2,-5.5h0.5v0.5h-0.5zM3,-5.5h1v0.5h-1zM-4.5,-5h0.5v1.5h-0.5zM2.5,-5h2v0.5h-2zM0,-4.5h4.5v0.5h-4.5zM-1,-4h5.5v1h-5.5zM-4,-3.5h1v0.5h-1zM-4,-3h1.5v0.5h-1.5zM-1,-3h5v0.5h-5zM-1.5,-2.5h1.5v0.5h-1.5zM1,-2.5h2v0.5h-2z',
    },
    {
      paint: 'blossomWhite',
      d: 'M-1,-8h1v0.5h-1zM-1.5,-7.5h3.5v0.5h-3.5zM-3,-7h5v0.5h-5zM-3,-6.5h4.5v0.5h-4.5zM-3.5,-6h5v0.5h-5zM2.5,-6h1v0.5h-1zM-4,-5.5h6v0.5h-6zM2.5,-5.5h0.5v0.5h-0.5zM-4,-5h0.5v0.5h-0.5zM-2,-5h4.5v0.5h-4.5zM-1.5,-4.5h1.5v0.5h-1.5zM-4,-4h0.5v0.5h-0.5z',
    },
    {
      paint: 'blossomPink',
      d: 'M1.5,-6.5h1v1h-1zM-3.5,-5h1.5v0.5h-1.5zM-4,-4.5h2.5v0.5h-2.5zM-3.5,-4h2.5v0.5h-2.5zM-3,-3.5h2v0.5h-2zM-2.5,-3h1.5v0.5h-1.5z',
    },
  ],
  pixels: 194,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'cherryTrunk',
      d: 'M0.5,-2.5h0.5v0.5h-0.5zM0,-2h1v3.5h-1zM0.5,1.5h0.5v0.5h-0.5zM0,2h1.5v0.5h-1.5zM-1,2.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'cherryBranch',
      d: 'M0,-2.5h0.5v0.5h-0.5zM-0.5,-2h0.5v3.5h-0.5zM-1,1.5h1.5v0.5h-1.5zM-1,2h1v0.5h-1z',
    },
    {
      paint: [
        ['blossomPink', 0.77],
        ['cherryTrunk', 0.23],
      ],
      d: 'M3,-5.5h1v0.5h-1zM2.5,-5h2v0.5h-2zM0,-4.5h2.5v0.5h-2.5zM3,-4.5h1.5v0.5h-1.5zM-4.5,-4h0.5v0.5h-0.5zM-2,-4h6v0.5h-6zM-4,-3.5h8.5v0.5h-8.5zM-3.5,-3h7.5v0.5h-7.5zM-1.5,-2.5h1.5v0.5h-1.5zM1,-2.5h2v0.5h-2zM-1.5,2.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'blossomPink',
      d: 'M-1,-8h1.5v0.5h-1.5zM-2.5,-7.5h1.5v0.5h-1.5zM0.5,-7.5h1.5v0.5h-1.5zM-3,-7h0.5v0.5h-0.5zM0.5,-7h2v0.5h-2zM-0.5,-6.5h3.5v0.5h-3.5zM-3.5,-6h1v0.5h-1zM-1.5,-6h5v0.5h-5zM-4,-5.5h7v0.5h-7zM-4.5,-5h5v0.5h-5zM1,-5h1.5v0.5h-1.5zM-4.5,-4.5h4.5v0.5h-4.5zM-4,-4h2v0.5h-2zM-4,-1h1v0.5h-1zM2,-0.5h0.5v0.5h-0.5zM2,0h1v0.5h-1zM-1.5,2h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['blossomPink', 0.3],
        ['blossomWhite', 0.7],
      ],
      d: 'M-1,-7.5h1.5v0.5h-1.5zM-2.5,-7h3v0.5h-3zM-3,-6.5h2.5v0.5h-2.5zM-2.5,-6h1v0.5h-1zM0.5,-5h0.5v0.5h-0.5zM2.5,-4.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 197,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
